import { Pipe, PipeTransform } from '@angular/core';

/**
 * ISO 4217 currency codes start with the issuing ISO 3166 country code
 * (EUR -> "eu", which flagcdn also serves).
 */
@Pipe({ name: 'currencyFlagUrl' })
export class CurrencyFlagUrlPipe implements PipeTransform {
  transform(currencyIso: string | null | undefined): string {
    if (!currencyIso) return '';

    return `https://flagcdn.com/w40/${currencyIso.slice(0, 2).toLowerCase()}.png`;
  }
}
